<template>
  <div id="wrap">
    <Header/>
    <Scroll/>
    <div class="mainSlider">
      <div class="swiper-container" id="my-swiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="item in statusData.rollingBannerData"
            :key="item.rolling_banner_ID"
          >
            <!-- Vue는 css에 props를 넘길 수가 없으니 반응형 크기에 따라 이미지를 어떤걸 표현할 지 판단하셔야 될거에요. -->
            <!-- 일단 모바일은 주석처리 해놓을게요.. -->
            <a :href="item.rolling_banner_link">
              <p class="mainslideImgBox mainslide_mobileImg">
                <img
                  :src=item.rolling_banner_image_mobile
                  :alt="item.rolling_banner_name"
                />
              </p>
              <p class="mainslideImgBox mainslide_pcImg">
                <img
                  :src=item.rolling_banner_image
                  :alt="item.rolling_banner_name"
                />
              </p>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="mall_mainSectWrap"> <!-- section -->
      <div class="mall_mainSectInner"> <!-- sectionInner -->
        <!-- <p class="mall_SectionTit">MAIN MAGAZINE</p>  --><!-- sectionTit -->
        <div class="mall_arrF_Box"> <!-- bannerContainer -->
          <div class="mall_arrF_LeftBox bannerEvent"> <!-- bannerItem bannerEvent -->
            <a href="/Product?pageTitle=Event&categoryType=event">
              <img
                :src="statusData.bannerEventImage === '' ? require(`@/assets/images/etc/no_image.gif`) :  statusData.bannerEventImage"
                alt="이벤트 배너 이미지"
              />
            </a>
          </div>
          <div class="mall_arrF_RightBox">
            <div class="mall_arrF_RightBoxTop">
              <div class="bannerProduct"> <!-- bannerItem bannerProduct -->
                <a :href="statusData.bannerPropsLink">
                  <img
                    :src="statusData.bannerPropsImage === '' ? require(`@/assets/images/etc/no_image.gif`) :  statusData.bannerPropsImage"
                    alt="소품 배너 이미지"
                  />
                </a>
              </div>
              <div class="bannerNotice"> <!-- bannerItem bannerNotice -->
                <a :href="statusData.bannerNoticeLink">
                  <img
                    :src="statusData.bannerNoticeImage === '' ? require(`@/assets/images/etc/no_image.gif`) :  statusData.bannerNoticeImage"
                    alt="공지사항 배너 이미지"
                  />
                </a>
              </div>
            </div>
            <div class="mall_arrF_RightBoxBottom bannerBest"> <!-- bannerItem bannerBest -->
              <a href="/Product?pageTitle=Best&categoryType=best">
                <img
                  :src="statusData.bannerBestImage === '' ? require(`@/assets/images/etc/no_image.gif`) :  statusData.bannerBestImage"
                  alt="베스트 배너 이미지"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mall_mainSectWrap"> <!-- section -->
      <div class="mall_mainSectInner"> <!-- sectionInner -->
        <p class="mall_SectionTit">QUICK DELIVERY</p> <!-- sectionTit -->
        <div class="mall_arrA_Box"><!-- sectionBox sectionBoxSlide -->
          <div class="mall_pListBox"
            v-for="item in statusData.instockData"
            :key="item.instock_ID"
          ><!--  sectionBox_info -->
            <div> <!-- sectionBox_info_inner -->
              <router-link :to="{
                name: 'ProductDetail',
                query: {product_ID: item.product_ID}
              }"
                class="mall_pListBox_Screen"
                ><!-- sectionBox_infoScreen -->
                <div class="mall_pListBox_img"> <!-- sectionMainImgBox -->
                  <p>
                    <img
                      :src="statusData.baseUrlExport + item.product_image"
                      :alt="'instock_'+item.instock_ID"
                    />
                  </p>
                  <p style="display:none;"> <!-- sectionMainImgHover -->
                    <img
                      :src="statusData.baseUrlExport + item.product_image_hover"
                      onerror="this.style.display='none';"
                      :alt="'instock_'+item.instock_ID"
                    />
                  </p>
                </div>

                <div class="mall_pListBox_txtBox"> <!-- sectionBox_infoText -->
                  <div class="mall_pListBox_txtBox_tit"> <!-- sectionBox_infoText_mainTit -->
                    <p>{{item.brand_eng_name}}</p>
                    <div class="mall_pListBox_stateTag"> <!-- sectionBox_infoTag -->
                      <div class="mall_pListBox_stateTag_new" v-if="item.product_new === 1">New</div> <!-- sectionBox_infoTag_new -->
                      <div class="mall_pListBox_stateTag_inStock" v-if="item.product_in_stock === 1">재고보유</div> <!-- sectionBox_infoTag_inStock -->
                      <div class="mall_pListBox_stateTag_best" v-if="item.product_best === 1">Best</div><!-- sectionBox_infoTag_best -->
                      <div class="mall_pListBox_stateTag_sale" v-if="item.product_sale === 1">Sale</div><!-- sectionBox_infoTag_sale -->
                      <div class="mall_pListBox_stateTag_expected" v-if="item.product_expected === 1">입고예정</div><!-- sectionBox_infoTag_expected -->
                      <div class="mall_pListBox_stateTag_soldOut" v-if="item.product_sold_out === 1">Sold out</div><!-- sectionBox_infoTag_soldOut -->
                      <div class="mall_pListBox_stateTag_event" v-if="item.product_event === 1">Event</div><!-- mall_pListBox_stateTag_event -->
                    </div>
                  </div>
                  <div class="mall_pListBox_txtBox_name">
                    <p>{{item.product_kor_name}}</p> <!-- sectionBox_infoText_sub01 -->
                    <p>{{item.product_eng_name}}</p> <!-- sectionBox_infoText_sub01_eng -->
                  </div>
                  <div class="mall_pListBox_txtBox_price"> <!-- sectionBox_infoText_sub02 -->
                    <template v-if="item.product_phone_inquiry_status === 1">
                      센텀점 문의
                    </template>
                    <template v-else-if="item.product_discount === 0" >
                        KRW {{ formatPrice(item.product_sale_price) }}
                    </template>
                    <div class="mall_pListBox_txtBox_priceDC" v-else> <!-- sectionBox_infoText_sub02_dc -->
                      <p>KRW {{ formatPrice(item.product_sale_price) }}</p> <!-- dc_origin -->
                      <p v-if="item.product_discount !== 0"> <!-- dc_dcPrice -->
                          KRW
                          {{formatPrice(item.product_discount)}}
                        </p>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <!-- <a href="/Product?pageTitle=In%20Stock&categoryType=inStock">
          <p class="btn_viewMore">VIEW MORE</p>
        </a> -->
      </div>
    </div>

    <div class="mall_mainSectWrap" :style="{ backgroundColor: statusData.bannerNfuPickBackground }">
      <div class="mall_mainSectInner">
        <p class="mall_SectionTit" :style="{ color: getTextColor(statusData.bannerNfuPickBackground) }">NFU PICK</p>
        <div class="mall_arrG_Box">
          <div class="mall_arrG_LeftBox">
            <div class="mall_arrG_LeftBoxInner">
              <a>
                <p class="mall_arrG_LeftBox_img">
                  <img
                    :src="statusData.bannerNfuPickImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  statusData.bannerNfuPickImageURL"
                    alt="NFU PICK 설명 이미지"
                  />
                </p>
                <p :style="{ color: getTextColor(statusData.bannerNfuPickBackground) }" class="mall_arrG_LeftBox_tit">
                  {{statusData.bannerNfuPickTitle}}
                </p>
                <p :style="{ color: getTextColor(statusData.bannerNfuPickBackground) }" class="mall_arrG_LeftBox_sub">
                  {{statusData.bannerNfuPickSubTitle}}
                </p>
              </a>
            </div>
          </div>
          <div class="mall_arrG_RightBox">
            <div class="mall_arrG_RightBoxInner" id="BannerSwiper"> <!-- swiper-container -->
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide mall_arrG_RightBox_cont"
                  v-for="item in statusData.nfuPickData"
                  :key="item.nfu_pick_ID"
                >
                  <router-link :to="{ name: 'ProductDetail', query: { product_ID: item.product_ID } }">
                    <div class="mall_arrG_RightBox_contImg">
                      <p>
                        <img
                          :src="statusData.baseUrlExport + item.product_image"
                          :alt="'nfu_pick_' + item.nfu_pick_ID"
                        />
                      </p>
                      <p style="display:none;">
                        <img
                          :src="statusData.baseUrlExport + item.product_image_hover"
                          onerror="this.style.display='none';"
                          :alt="'nfu_pick_' + item.nfu_pick_ID"
                        />
                      </p>
                    </div>
                  </router-link>
                </div>
              </div>
              <!-- ✅ 네비게이션 버튼 추가 (swiper-container 밖에서 배치) -->
            </div>
            <p class="mall_arrG_swipePrev"></p> <!-- swiper-button-prev -->
            <p class="mall_arrG_swipeNext"></p> <!-- swiper-button-next -->
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="mall_mainSectWrap">
      <div class="mall_mainSectInner">
        <p class="mall_SectionTit">MONTHLY BEST</p>
        <div class="mall_arrA_Box">
          <div class="mall_pListBox"
            v-for="item in statusData.monthlyBestData"
            :key="item.monthly_best_ID"
          >
            <div>
              <router-link :to="{
                name: 'ProductDetail',
                query: {product_ID: item.product_ID}
              }"
                class="mall_pListBox_Screen"
                >
                <div class="mall_pListBox_img">
                  <p>
                    <img
                      :src="statusData.baseUrlExport + item.product_image"
                      :alt="'monthly_best_'+item.monthly_best_ID"
                    />
                  </p>
                  <p style="display:none;">
                    <img
                      :src="statusData.baseUrlExport + item.product_image_hover"
                      onerror="this.style.display='none';"
                      :alt="'monthly_best_'+item.monthly_best_ID"
                    />
                  </p>
                </div>
                <div class="mall_pListBox_txtBox">
                  <div class="mall_pListBox_txtBox_tit">
                    <p>{{item.brand_eng_name}}</p>
                    <div class="mall_pListBox_stateTag">
                      <div class="mall_pListBox_stateTag_new" v-if="item.product_new === 1">New</div>
                      <div class="mall_pListBox_stateTag_inStock" v-if="item.product_in_stock === 1">재고보유</div>
                      <div class="mall_pListBox_stateTag_best" v-if="item.product_best === 1">Best</div>
                      <div class="mall_pListBox_stateTag_sale" v-if="item.product_sale === 1">Sale</div>
                      <div class="mall_pListBox_stateTag_expected" v-if="item.product_expected === 1">입고예정</div>
                      <div  class="mall_pListBox_stateTag_soldOut" v-if="item.product_sold_out === 1">Sold out</div>
                      <div  class="mall_pListBox_stateTag_event" v-if="item.product_event === 1">Event</div>
                    </div>
                  </div>
                  <div class="mall_pListBox_txtBox_name">
                    <p>{{item.product_kor_name}}</p>
                    <p>{{item.product_eng_name}}</p>
                  </div>
                  <div class="mall_pListBox_txtBox_price">
                    <template v-if="item.product_phone_inquiry_status === 1">
                      센텀점 문의
                    </template>
                    <template v-else-if="item.product_discount === 0" >
                        KRW {{ formatPrice(item.product_sale_price) }}
                    </template>
                    <div class="mall_pListBox_txtBox_priceDC" v-else>
                      <p>KRW {{ formatPrice(item.product_sale_price) }}</p>
                      <p v-if="item.product_discount !== 0">
                          KRW
                          {{formatPrice(item.product_discount)}}
                        </p>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="mall_mainSectWrap">
      <div class="mall_mainSectInner">
        <p class="mall_SectionTit">LIVING ACC</p>
        <div class="mall_arrA_Box">
          <div class="mall_pListBox"
            v-for="item in statusData.livingAccData"
            :key="item.living_acc_ID"
          >
            <div>
              <router-link :to="{
                name: 'ProductDetail',
                query: {product_ID: item.product_ID}
              }"
                class="mall_pListBox_Screen"
                >
                <div class="mall_pListBox_img">
                  <p>
                    <img
                      :src="statusData.baseUrlExport + item.product_image"
                      :alt="'living_acc_'+item.living_acc_ID"
                    />
                  </p>
                  <p style="display:none;">
                    <img
                      :src="statusData.baseUrlExport + item.product_image_hover"
                      onerror="this.style.display='none';"
                      :alt="'living_acc_'+item.living_acc_ID"
                    />
                  </p>
                </div>

                <div class="mall_pListBox_txtBox">
                  <div class="mall_pListBox_txtBox_tit">
                    <p>{{item.brand_eng_name}}</p>
                    <div class="mall_pListBox_stateTag">
                      <div class="mall_pListBox_stateTag_new" v-if="item.product_new === 1">New</div>
                      <div class="mall_pListBox_stateTag_inStock" v-if="item.product_in_stock === 1">재고보유</div>
                      <div class="mall_pListBox_stateTag_best" v-if="item.product_best === 1">Best</div>
                      <div class="mall_pListBox_stateTag_sale" v-if="item.product_sale === 1">Sale</div>
                      <div class="mall_pListBox_stateTag_expected" v-if="item.product_expected === 1">입고예정</div>
                      <div class="mall_pListBox_stateTag_soldOut" v-if="item.product_sold_out === 1">Sold out</div>
                      <div class="mall_pListBox_stateTag_event" v-if="item.product_event === 1">Event</div>
                    </div>
                  </div>
                  <div class="mall_pListBox_txtBox_name">
                    <p>{{item.product_kor_name}}</p>
                    <p>{{item.product_eng_name}}</p>
                  </div>
                  <div class="mall_pListBox_txtBox_price">
                    <template v-if="item.product_phone_inquiry_status === 1">
                      센텀점 문의
                    </template>
                    <template v-else-if="item.product_discount === 0" >
                        KRW {{ formatPrice(item.product_sale_price) }}
                    </template>
                    <div class="mall_pListBox_txtBox_priceDC" v-else>
                      <p>KRW {{ formatPrice(item.product_sale_price) }}</p>
                      <p v-if="item.product_discount !== 0">
                          KRW
                          {{formatPrice(item.product_discount)}}
                        </p>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 가로 배너 -->
    <div class="mall_arrE_Box">
      <a :href="statusData.bannerWidthLink">
        <p class="mall_arrE_MobImg">
          <img
            :src="statusData.bannerWidthMobileImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  statusData.bannerWidthMobileImageURL"
            alt="모바일 가로 배너 이미지"
          />
        </p>
        <p class="mall_arrE_pcImg">
          <img
            :src="statusData.bannerWidthImageURL === '' ? require(`@/assets/images/etc/no_image.gif`) :  statusData.bannerWidthImageURL"
            alt="PC 가로 배너 이미지"
          />
        </p>
      </a>
    </div>

    <div class="mall_mainSectWrap"> <!-- section -->
      <div class="mall_mainSectInner"> <!-- sectionInner -->
        <p class="mall_SectionTit">STYLING</p> <!-- sectionTit -->
        <div class="mall_arrC_Box"> <!-- sectionBox sectionBoxSlide -->
          <div class="mall_arrC_contBox"
            v-for="item in statusData.StylingData"
            :key="item.styling_ID"
          >
            <router-link :to="{name: 'StylingDetail', query: {styling_ID: item.styling_ID}}">
              <p class="mall_arrC_img">
                <img
                  :src="item.styling_main_image"
                  :alt="item.styling_title"
                />
              </p>
              <div class="mall_arrC_txtBox">
                <p class="mall_arrC_txtBox_tit">{{item.styling_title}}</p>
                <p>{{item.styling_sub_title}}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="mall_mainSectWrap"> <!-- section -->
      <div class="mall_mainSectInner"><!-- sectionInner -->
        <p class="mall_SectionTit">INSTAGRAM</p> <!-- sectionTit -->
        <div class="mall_arrD_Box"> <!-- sectionBox sectionBox_mainInstagram -->
          <div class="mall_arrD_contBox"
            v-for="item in statusData.instagramData"
            :key="item.instagram_ID"
          > <!-- sectionBox_instagram -->
            <a :href="item.instagram_link" target="_blank">
              <img
                :src="item.instagram_main_image"
                :alt="item.instagram_title"
              />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="mall_mainSectWrap"> <!-- section -->
      <div class="mall_mainSectInner"> <!-- sectionInner sectionInnerSize -->
        <p class="mall_SectionTit">BRAND</p> <!-- sectionTit -->
        <div class="mall_arrB_Box"> <!-- sectionBox -->
          <div class="mall_arrB_contBox"
            v-for="item in statusData.brandData"
            :key="item.brand_ID"
          > <!-- sectionBox_sectionBrand -->
            <router-link :to="{name: 'BrandDetail', query: {brand_ID: item.brand_ID}}" >
              <div class="mall_arrB_imgBox"> <!-- sectionImgBrand -->
                <p class="mall_arrB_logoImg"><!-- 브랜드 로고 sectionBrand_ImgBoxLogo -->
                  <img
                    :src="item.brand_logo_image"
                    :alt="item.brand_kor_name"
                  />
                </p>
                <p class="mall_arrB_hoverImg"><!-- 하버 배경이미지 sectionBrand_ImgBoxHover-->
                  <img
                    :src="item.brand_logo_hover"
                    :alt="item.brand_eng_name"
                  />
                </p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <Footer/>

  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import {
  get_rolling_banner_use,
  get_brand_use,
  get_instagram_main_use,
  get_instock_main_use,
  get_nfu_pick_main_use,
  get_monthly_best_main_use,
  get_living_acc_main_use,
  get_styling_main_use,
  get_banner,
  base_url_export
} from '../../ETC/Axios.vue'

export default {
  name: 'Main',
  components: {
    Header: Header,
    Footer: Footer,
    Scroll: Scroll
  },
  setup () {
    return {
      statusData: ref({
        rollingBannerData: [],
        instockData: [],
        nfuPickData: [],
        monthlyBestData: [],
        livingAccData: [],
        StylingData: [],
        brandData: [],
        instagramData: [],
        bannerEventImage: '',
        bannerPropsImage: '',
        bannerPropsLink: '',
        bannerNoticeImage: '',
        bannerNoticeLink: '',
        bannerBestImage: '',
        bannerNfuPickBackground: '',
        bannerNfuPickImageURL: '',
        bannerNfuPickTitle: '',
        bannerNfuPickSubTitle: '',
        bannerWidthMobileImageURL: '',
        bannerWidthImageURL: '',
        bannerWidthLink: '',
        baseUrlExport: base_url_export
      })
    }
  },
  methods: {
    formatPrice (price) {
      return String(Math.floor(price)).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getTextColor (hexColor) {
    // # 제거 후 RGB 값 추출
      const color = hexColor.replace('#', '')
      const r = parseInt(color.substr(0, 2), 16)
      const g = parseInt(color.substr(2, 2), 16)
      const b = parseInt(color.substr(4, 2), 16)

      // 밝기 계산 (일반적으로 사용하는 공식)
      const brightness = (r * 0.299 + g * 0.587 + b * 0.114)

      // 밝기가 128 이상이면 검정색, 그렇지 않으면 흰색 반환
      return brightness >= 128 ? '#000000' : '#FFFFFF'
    }
  },
  mounted () {
    get_rolling_banner_use().then(result_data => {
      this.statusData.rollingBannerData = result_data
      // eslint-disable-next-line no-undef, no-unused-vars
      const slide = new Swiper('#my-swiper', {
        slidesPerView: 1, // 한 슬라이드에 보여줄 갯수
        spaceBetween: 0, // 슬라이드 사이 여백
        speed: 800, // 슬라이드 넘어가는 속도
        loop: true, // 슬라이드 반복 여부
        loopedSlides: 1,
        loopAdditionalSlides: 1, // 슬라이드 반복 시 마지막 슬라이드에서 다음 슬라이드가 보여지지 않는 현상 수정
        pagination: true, // pager 여부
        freemode: false,
        autoplay: { // 자동 슬라이드 설정 , 비 활성화 시 false
          delay: 5000, // 시간 설정
          disableOnInteraction: false // false로 설정하면 스와이프 후 자동 재생이 비활성화 되지 않음
        }
      })
    })
    get_instock_main_use().then(result_data => {
      this.statusData.instockData = result_data
    })
    get_nfu_pick_main_use().then(result_data => {
      this.statusData.nfuPickData = result_data
      // eslint-disable-next-line no-undef, no-unused-vars
      const slide = new Swiper('#BannerSwiper', {
        // speed: 800,
        // loop: true, // 슬라이드가 slidePerView 2배 되야 적용됨.
        init: true, // 임시로 loop 반복할 수 있도록 작성
        initialSlide: 0,
        loopedSlides: 1,
        loopAdditionalSlides: 1, // 슬라이드 반복 시 마지막 슬라이드에서 다음 슬라이드가 보여지지 않는 현상 수정
        navigation: { nextEl: '.mall_arrG_swipeNext', prevEl: '.mall_arrG_swipePrev' },
        autoplay: { delay: 5000, disableOnInteraction: false },
        centeredSlides: false,

        breakpoints: {
          360: {
            slidesPerView: 1.4,
            freemode: true
          },
          769: {
            slidesPerView: 2.1
          },
          1100: {
            slidesPerView: 3.3
          }
        }
      })
    })
    get_monthly_best_main_use().then(result_data => {
      this.statusData.monthlyBestData = result_data
    })
    get_living_acc_main_use().then(result_data => {
      this.statusData.livingAccData = result_data
    })
    get_styling_main_use().then(result_data => {
      this.statusData.StylingData = result_data
    })
    get_brand_use().then(result_data => {
      this.statusData.brandData = result_data
    })
    get_instagram_main_use().then(result_data => {
      this.statusData.instagramData = result_data
    })
    get_banner().then((result) => {
      this.statusData.bannerEventImage = result[0].banner_event_image
      this.statusData.bannerPropsImage = result[0].banner_props_image
      this.statusData.bannerPropsLink = result[0].banner_props_link
      this.statusData.bannerNoticeImage = result[0].banner_notice_image
      this.statusData.bannerNoticeLink = result[0].banner_notice_link
      this.statusData.bannerBestImage = result[0].banner_best_image
      this.statusData.bannerNfuPickBackground = result[0].banner_nfu_pick_background
      this.statusData.bannerNfuPickImageURL = result[0].banner_nfu_pick_image
      this.statusData.bannerNfuPickTitle = result[0].banner_nfu_pick_title
      this.statusData.bannerNfuPickSubTitle = result[0].banner_nfu_pick_sub_title
      this.statusData.bannerWidthImageURL = result[0].banner_width_image
      this.statusData.bannerWidthMobileImageURL = result[0].banner_width_mobile_image
      this.statusData.bannerWidthLink = result[0].banner_width_link
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Main/Main.vue